import { Spin, Tooltip } from 'antd';
import Cross from 'assets/svg/Cross';
import Plus from 'assets/svg/Plus';
import { LoadingOutlined } from '@ant-design/icons';

import { truncateLabel } from 'utils/helperMethods';
import { colorConstants } from 'config/colorConstants';

type CustomTabsProps = {
    tabs: Array<{ key: string; label: string }>;
    activeTab: string | null;
    setActiveTab?: Function;
    showAddButton?: boolean;
    addButtonText?: string;
    isViewMode?: boolean;
    onAddBtnClick: Function;
    isAddDisabled: boolean;
    handleTabDelete?: (id: string, label: string) => void;
    isDeleteDisabled?: boolean;
    deleteBtnDisabledTooltip?: string;
    showLoader?: boolean;
};

const CustomTabs = ({
    tabs,
    activeTab,
    setActiveTab,
    showAddButton,
    addButtonText = 'Add Promo',
    isViewMode,
    onAddBtnClick,
    isAddDisabled,
    handleTabDelete,
    isDeleteDisabled = false,
    deleteBtnDisabledTooltip = '',
    showLoader = false,
}: CustomTabsProps) => {
    return (
        <div className="w-full  pb-2">
            {/* Tabs */}
            <div className="flex gap-8 border-b border-backgroundGreyAlt6 pb-2">
                {tabs.map((tab, index: number) => (
                    <div
                        className={` flex gap-2 justify-between items-center relative  text-sm font-sm transition-colors duration-200 
                    ${
                        activeTab === tab.key
                            ? "text-purpleFont after:content-[''] after:absolute after:left-0 after:bottom-[-8px] after:w-full after:h-[2px] after:bg-purpleFont"
                            : 'text-promoColour hover:text-blue-500'
                    }`}
                    >
                        <Tooltip title={tab.label || 'New Promo'}>
                            <button key={tab.key} onClick={() => setActiveTab && setActiveTab(tab.key)}>
                                {truncateLabel(tab.label || 'New Promo', 20)}
                            </button>
                        </Tooltip>
                        {!isViewMode && (
                            <Tooltip title={isDeleteDisabled ? deleteBtnDisabledTooltip : ''}>
                                <span
                                    className="cursor-pointer"
                                    onClick={
                                        handleTabDelete && !isDeleteDisabled
                                            ? () => handleTabDelete(tab.key, tab.label)
                                            : () => {}
                                    }
                                >
                                    <Cross />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                ))}

                {!isViewMode && showAddButton && (
                    <button
                        className="flex justify-center items-center gap-2 disabled:bg-red-500 disabled:opacity-40"
                        onClick={() => {
                            !isViewMode && onAddBtnClick();
                        }}
                        disabled={isAddDisabled || showLoader}
                    >
                        {showLoader ? (
                            <Spin indicator={<LoadingOutlined style={{ color: colorConstants.purpleFont }} />} />
                        ) : (
                            <Plus />
                        )}
                        {addButtonText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default CustomTabs;
